import API from "..";

export default class SpecialAnalysisPriority {

  constructor({
    priorityName,
    isActive,
    priorityLevel
  }) 
    
  {
    this.priorityName = priorityName;
    this.isActive = isActive;
    this.priorityLevel = priorityLevel
  }

  static async getAll() {
    const api = await API();
    const { data } = await api.get(`/specialAnalysisPriority`);
    if (data.result) {
        return data.result.map((d) => new SpecialAnalysisPriority(d));
    }
    else {
        return [];
    }
  }
}
